import { css } from 'styled-components';

const uppercase = (props) => {
    if (!props.$uppercase)
        return;
    return css `
    text-transform: uppercase;
    letter-spacing: 1px;
  `;
};

export { uppercase };
//# sourceMappingURL=uppercase.js.map
